import { createModel } from '@rematch/core'
import * as firebase from 'firebase'
import * as R from 'ramda'

interface IParticipantState {
  [lectureId: string]: string[]
}

export default createModel({
  state: {} as IParticipantState,
  reducers: {
    updateById: (
      state: IParticipantState,
      payload: { lectureId: string; participantIds: string[] }
    ): IParticipantState => ({
      ...state,
      [payload.lectureId]: payload.participantIds
    })
  },
  effects: {
    async fetchParticipants() {
      const getParticipants = firebase
        .functions()
        .httpsCallable('lecture-getParticipants')
      getParticipants().then(res => {
        const participants = res.data
        R.keys(participants).map(lectureId =>
          this.updateById({
            lectureId,
            participantIds: R.reverse(participants[lectureId])
          })
        )
      })
    }
  },
  selectors: {
    getByLectureId: (state: IParticipantState, lectureId: string) => {
      return state[lectureId] ? state[lectureId] : null
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/participants.ts